var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailTrashList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface/outline/trash 01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6667 5.99967L12.1894 12.2042C12.0825 13.5935 10.924 14.6663 9.53058 14.6663H6.46942C5.07599 14.6663 3.91748 13.5935 3.8106 12.2042L3.33333 5.99967M14 4.66634C12.2681 3.82233 10.2091 3.33301 8 3.33301C5.7909 3.33301 3.73194 3.82233 2 4.66634M6.66667 3.33301V2.66634C6.66667 1.92996 7.26362 1.33301 8 1.33301C8.73638 1.33301 9.33333 1.92996 9.33333 2.66634V3.33301M6.66667 7.33301V11.333M9.33333 7.33301V11.333",
    stroke: "#868687",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailTrashList);
export default __webpack_public_path__ + "static/media/mail_trash_list.d855ceaa1aed90923fbeff018577b3ef.svg";
export { ForwardRef as ReactComponent };